import { API_BASE_URL } from "../../../config";

export const defaultFormTemplate = {
      contact_id: null,
      name: null,
      mobile:null,
      wa_number:null,
      email:null,
      designation:null,
      department:null,
      contact_type:'work',
      contact_type_other:null,
      is_primary_global:0,
      additional_fields:null,
      modified_by:null,
      created_date:null,
      modified_date:null,
      status: 'active',
};
export const validationRules = {
  name: { required: true, maxLength: 100,pattern: { value: /^(?! )[A-Za-z]+( [A-Za-z]+)*(?<! )$/, message: 'Special characters are not allowed.'} },
  email:{pattern: { value: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z]{2,})+$/, message: 'Invaild email address.' }},
  contact_type_other:{ required: true},
};
export const defaultColumns = [
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"contact_id","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentContacts":""},
  {"fieldID":"","fieldLabel":"","fieldType":"varchar(200)","column_name":"name","linkedWith":"","fieldOptions":"","dateFormat":"","displayFormat":"","parentContacts":""},
];
export const columnLabels = {
  customer_id: 'Contact ID',
  name: 'Contact Name',
  wa_number:"Whatsapp Number",
  mobile:"Mobile Number",
  contact_type_other:"Contact Other Details"
  };

export const  skipFields=['additional_fields',];
export const  filterSkipFields=["additional_fields"];
export  const fieldOverrides = {
            created_by: {
              type: 'smartSelectInput',
              config: {
                label: 'Created By',
                type: 'admin',
                source: 'admin',
                valueKey:'adminID',
                placeholder: 'Select Created By',
                check: 'name',
                getLabel: (item) => `${item.name}`,
                getValue: (item) => item.adminID,
                allowAddNew: false,preload: true,cache: true,showRecent: true,multi:false,
                list: 'name,adminID'
              }
            },
            contact_type: {
              type: 'dropdown',
              label: 'Contact Type',
              options: [
                  { value: 'work', label: 'Work' },
                  { value: 'personal', label: 'Personal' },
                  { value: 'other', label: 'Other' }
                ]
              },
            status: {
              type: 'radio',
              label: 'Status',
              options: [
                  { value: 'active', label: 'Active' },
                  { value: 'inactive', label: 'In Active' }
                ]
              },
          };
export const directSchemaTemplate = [
  { Field: 'contact_id', Type: 'int' },
  { Field: 'name', Type: 'varchar' },
  { Field: 'mobile', Type: 'varchar' },
  { Field: 'wa_number', Type: 'varchar' },
  { Field: 'email', Type: 'varchar' },
  { Field: 'designation', Type: 'varchar' },
  { Field: 'department', Type: 'varchar' },
  { Field: 'contact_type', Type:  `enum('work', 'personal', 'other')` },
  { Field: 'contact_type_other', Type: 'varchar' },
  { Field: 'is_primary_global', Type: 'enum(1,0)' },
  { Field: 'modified_by', Type: 'int' },
  { Field: 'created_by', Type: 'smartSelectInput' },
  { Field: 'created_date', Type: 'date' },
  { Field: 'modified_date', Type: 'date' },
  { Field: 'status', Type: `enum(active,inactive)` },
];


export const layout = [
    {
      label: 'Basic Info',
      row: [
     { field: 'name',colSize:'w-full mb-3 md:w-1/3' },
     { custom: 'mobile' ,colSize:'w-full mb-3 md:w-1/3'},
     { custom: 'wa_number'},
      ]
    },
    {
      row: [
      { field: 'email',colSize:'w-full mb-3 md:w-1/3'},
      { field: 'designation',colSize:'w-full mb-3 md:w-1/3' },
      { field: 'department'},
      
      ]
    },
    {
      row: [
      { field: 'contact_type',colSize:'w-full mb-3 md:w-1/3' },
      { field: 'contact_type_other',colSize:'w-full mb-3 md:w-1/3', showWhen: {
          and: [{ field: 'contact_type', value: 'other' }, { field: 'contact_type_other'}]
          }, },
      ]
    },
    {
      row: [
       { addcustomFieldBtn: false },{ customFieldsPlaceholder: true }
      ]
    },
  ];
  export const infoIcons = {
    
  };